import React, {useEffect} from "react";
import {Link, useHistory} from "react-router-dom";
import './AnalizaMain.css'
import * as BiIcons from "react-icons/bi";


export default function Zaawansowane(){

	useEffect(()=>{
		document.title="Analiza matematyczna";
	},[])

	const { push } = useHistory();

	const comeBackFunc=()=>{
		push('/analiza');
	}

	return(
		<div className='conceptsContainer'>
			<div className='comeBackDiv' onClick={comeBackFunc}>
				<BiIcons.BiArrowBack/>
				<div style={{textAlign: 'left', alignItems: 'left'}}>Cofnij</div>
			</div>

			<div className=' listOfButtons'>
				<Link to="/analiza/pochodne" className='link'><button className='analizaLinks'>Pochodne</button></Link>
				<Link to="/analiza/liczby-zespolone" className='link'><button className='analizaLinks'>Liczby zespolone</button></Link>
				<Link to="/analiza/calki" className='link'><button className='analizaLinks'>Całki</button></Link>
				<br/><br/><br/>
			</div>
		</div>
	);
}